import type { PartialMessages } from "../messages";

export const cs: PartialMessages = {
  "status.syncing": "Synchronizováno", "status.connecting": "Připojování", "status.full": "Plno", "status.closed": "Odpojeno",
  "toast.connecting": "Připojování…", "toast.reconnecting": "Spojení ztraceno. Zkouším znovu…",
  "toast.retrying": "Za chvíli to zkusím znovu.", "toast.busy": "Právě je velký provoz",
  "notice.mapChanged": "{name} přepnul mapu",
  "hint.place": "Klikni pro umístění, tažením zadáš směr (Esc zruší)",
  "kind.objective": "Cíl", "kind.rally": "Sraz", "kind.enemy": "Nepřítel", "kind.loot": "Loot",
  "kind.extract": "Extrakce", "kind.danger": "Nebezpečí", "kind.self": "Já", "kind.ping": "Sem!",
  "hint.objective": "Kam míříte", "hint.rally": "Místo srazu",
  "hint.enemy": "Otoč ho tam, odkud jsi ho viděl", "hint.loot": "Vzácné bedny, těla",
  "hint.extract": "Plánovaná extrakce", "hint.danger": "Miny, odstřelovači, otevřený terén",
  "hint.self": "Tvoje pozice. Nová smaže předchozí",
  "hint.ping": "Dočasná značka, po 25 sekundách zmizí",
  "tool.clearMine": "Smazat moje", "tool.clearMineHint": "Odstraní všechny značky, které jsi umístil",
  "sidebar.map": "Mapa (pro všechny)", "sidebar.styleSvg": "Kreslená", "sidebar.styleTile": "Satelit",
  "sidebar.floors": "Patro (mění jen tvůj pohled)", "sidebar.groundFloor": "Přízemí",
  "sidebar.floorNote": "Značky z jiných pater jsou zesvětlené.",
  "sidebar.members": "{count} v místnosti", "sidebar.you": "ty", "sidebar.guest": "host",
  "sidebar.clearAll": "Smazat všechny značky", "sidebar.openWindow": "Otevřít v okně (jen pro mě)",
  "sidebar.invite": "Pozvat někoho", "sidebar.help": "Jak na to", "sidebar.feedback": "Poslat zpětnou vazbu",
  "sidebar.mapData": "Data mapy", "sidebar.license": "Licence", "sidebar.licenseNote": "jen nekomerční užití",
  "sidebar.room": "Místnost",
  "pin.facing": "Směr", "pin.floor": "Patro", "pin.map": "Mapa", "pin.noFacing": "Bez směru",
  "pin.facingValue": "{compass} ({degrees}°)",
  "pin.notePlaceholder": "Přidat poznámku (např. okno ve třetím patře)",
  "pin.removeMine": "Smazat tuto značku", "pin.removeOther": "Smazat cizí značku", "pin.close": "Zavřít",
  "compass.n": "S", "compass.ne": "SV", "compass.e": "V", "compass.se": "JV",
  "compass.s": "J", "compass.sw": "JZ", "compass.w": "Z", "compass.nw": "SZ",
  "handoff.title": "Otevřít v okně",
  "handoff.lede": "Odkaz pro tebe. Otevře stejnou místnost v prohlížeči, aby Discord dál ukazoval sdílenou obrazovku a mapa byla na druhém monitoru.",
  "handoff.open": "Otevřít v prohlížeči tohoto počítače", "handoff.or": "Na jiném zařízení",
  "handoff.codeHint": "Na tom zařízení otevři {host}/j/ a zadej kód výše.",
  "handoff.copy": "Kopírovat odkaz", "handoff.copied": "Zkopírováno",
  "handoff.copyFailed": "Označeno výše — stiskni Ctrl+C",
  "handoff.expiry": "Odkaz funguje jednou. Vyprší za {time}.",
  "handoff.warn": "Nepředávej ho dál: otevřením se spotřebuje. K tomu slouží „Pozvat někoho“.",
  "handoff.creating": "Vytvářím odkaz…", "handoff.failed": "Odkaz se nepodařilo vytvořit",
  "invite.title": "Pozvat někoho",
  "invite.lede": "Přiveď někoho, kdo není na hlasovém kanálu. Zadá jméno a bude moci umísťovat značky.",
  "invite.copy": "Kopírovat odkaz", "invite.warn": "Kdokoli s tímto odkazem se může připojit. Nezveřejňuj ho.",
  "invite.budget": "Ještě {left} lidí, vyprší za {time} (využito {used}/{max}).",
  "invite.revoke": "Zneplatnit odkaz hned", "invite.revoked": "Odkaz zneplatněn.",
  "invite.creating": "Vytvářím odkaz…", "invite.failed": "Odkaz se nepodařilo vytvořit",
  "invite.revokeFailed": "Zneplatnění se nepovedlo",
  "join.title": "Připojit se k mapě",
  "join.lede": "Někdo tě pozval na mapu raidu. Zvol jméno — objeví se u tvých značek.",
  "join.name": "Jméno", "join.go": "Připojit se", "join.joining": "Připojuji…", "join.failed": "Připojení se nezdařilo",
  "feedback.title": "Napsat autorovi", "feedback.request": "Návrh", "feedback.bug": "Chyba",
  "feedback.other": "Jiné", "feedback.requestHint": "Bylo by fajn, kdyby…",
  "feedback.bugHint": "Něco nefunguje", "feedback.otherHint": "Cokoli",
  "feedback.placeholder": "např. chtěl bych kreslit čáry, ne jen šipky / na Streets se nepřepínají patra",
  "feedback.note": "Spolu se zprávou se odešle tvoje jméno na Discordu a ID, abychom mohli odpovědět.",
  "feedback.send": "Odeslat", "feedback.sending": "Odesílám…", "feedback.sent": "Odesláno. Díky!",
  "feedback.failed": "Odeslání se nezdařilo",
  "time.minutes": "{n} min", "time.hoursMinutes": "{h} h {m} min",
  "error.roomFull": "Tato místnost je plná",
  "error.tooManyWindows": "Příliš mnoho oken této místnosti. Jedno zavři.",
  "error.serverFull": "Server je plný", "error.session": "Relace už neplatí. Otevři to znovu.",
  "error.handoffSpent": "Tenhle odkaz nefunguje. Je jednorázový a jen pro toho, kdo ho vytvořil. Chceš-li někoho přizvat, vytvoř na mapě pozvánku.",
  "error.inviteSpent": "Tato pozvánka už neplatí. Vyžádej si nový odkaz.",
  "error.inviteNotOwner": "Zneplatnit odkaz může jen jeho tvůrce",
  "error.noRoom": "Nebyla zadána místnost", "error.needName": "Zadej jméno",
  "error.tooShort": "Napiš toho prosím o něco víc", "error.tooLong": "Je to příliš dlouhé",
  "error.badKind": "Neplatná kategorie",
  "error.rateLimited": "Příliš mnoho zpráv. Počkej asi 10 minut.",
  "error.busy": "Je velký provoz. Zkus to za chvíli.",
  "error.sendFailed": "Odeslání se nezdařilo. Zkus to později.",
  "error.feedbackClosed": "Zpětná vazba je momentálně uzavřená",
  "error.sessionGone": "Původní relace skončila. Otevři aktivitu znovu.",
  "landing.tagline1": "Sdílej mapu Tarkova",
  "landing.tagline2": "se všemi na hovoru na Discordu a vysvětlete si ji spolu.",
  "landing.install": "Přidat do Discordu",
  "landing.installNote": "Zdarma. Spustíš ikonou rakety v hlasovém kanálu.",
  "landing.body": "Všichni na hovoru vidí stejnou mapu. Kliknutí položí značku a tažením k ní přidáš šipku směru — ukážeš nejen kde, ale i kudy.",
  "landing.point1": "Stačí být na stejném hovoru. Žádné kódy",
  "landing.point2": "Všech 13 map. Kreslené i satelitní, a patra",
  "landing.point3": "Značky zůstávají, můžeš se k nim vrátit",
  "landing.point4": "Kdo není na hovoru, přijde přes pozvánku",
  "landing.footNote": "Hry se to nikdy nedotkne. Žádné soubory, žádná paměť, nic vykresleného přes hru. Každou značku klade člověk ručně.",
  "landing.footCredit": "Koníčkový projekt, běží zdarma. Data map z {tarkovdev} (CC BY-NC-SA 4.0). Escape from Tarkov je produkt Battlestate Games Limited; tohle je neoficiální fanouškovský projekt bez vazby na ně.",
  "landing.updates": "Novinky", "landing.allUpdates": "Všechny novinky",
  "boot.connecting": "Připojování k Discordu…", "boot.failedTitle": "Nepodařilo se spustit",
};
